import clsx from 'clsx'
// import useClickOutside from 'hooks/useClickOutside'
import {
  forwardRef,
  JSXElementConstructor,
  PropsWithoutRef,
  ReactNode,
} from 'react'
import mergeRefs from 'react-merge-refs'
import { CheckIcon } from '@heroicons/react/solid'

interface Props
  extends PropsWithoutRef<JSX.IntrinsicElements['div']> {
  checked: boolean
  disabled?: boolean
  children?: ReactNode
  as?: string | JSXElementConstructor<any>
  outerProps?: PropsWithoutRef<JSX.IntrinsicElements['div']>
}

let CheckButton = forwardRef<HTMLDivElement, Props>(
  (props, outerRef) => {
    let {
      checked,
      children,
      as: Component = 'div',
      outerProps,
      ...rest
    } = props

    // let [ref, selected, setSelected] = useClickOutside(false)

    return (
      <div
        className={clsx({
          'cursor-not-allowed text-grey': props.disabled,
          'cursor-pointer': !props.disabled,
        })}
        // onClick={() => setSelected(true)}
        {...outerProps}
      >
        <Component
          ref={mergeRefs([
            // ref,
            outerRef,
          ])}
          {...rest}
        >
          <div
            role='checkbox'
            aria-checked={checked}
            className={clsx(
              'flex-shrink-0 w-6 h-6 rounded-md bg-lightYellow flex items-center justify-center',
              {
                'cursor-not-allowed bg-grey border-greyA1':
                  props.disabled,
                'cursor-pointer': !props.disabled,
              }
              // {
              //   '': selected,
              //   '': !selected
              // }
            )}
          >
            {checked && (
              <div
                className={clsx('flex-shrink-0 w-[90%] h-[90%]', {
                  'opacity-30': props.disabled,
                })}
              >
                <CheckIcon className='text-dark' />
              </div>
            )}
          </div>

          {children}
        </Component>
      </div>
    )
  }
)

export default CheckButton
